export default import.meta.ROLLDOWN_FILE_URL_FKW6qOIiMWcVdWo2taY49w